import { AmountUsd } from '@ui/components/Amount/AmountUsd';
import { useTokenDisplayDecimals } from '@ui/hooks/useTokenDisplayDecimals';

import { useMarketPrice } from '../../hooks/useMarketPrice';
import { useTradingPair } from '../../store/useTradingPair';

export const MarketPrice = () => {
  const marketPrice = useMarketPrice();

  const currentTradePairInfo = useTradingPair((s) => s.useTradingPair());
  const priceDisplayDecimals = useTokenDisplayDecimals(
    currentTradePairInfo?.baseSymbol,
    currentTradePairInfo?.priceDisplayDecimals,
  );

  return (
    <AmountUsd
      textAlign="end"
      color="greyWhite.lightGrey1"
      value={marketPrice}
      opts={{
        displayDecimals: priceDisplayDecimals,
      }}
      data-cy="MarketPrice"
      data-cy-value={marketPrice}
    />
  );
};
